import { Dispatch, SetStateAction, useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { CustomValidationConfig, CustomValidationConstraint, CustomValidationError } from "go-form/services/types";
import { CsvImportOverviewFormType, ImportOverviewFormSelects } from "../../../../../services/types";

interface Props {
	form: UseFormReturn<CsvImportOverviewFormType>;
	formSelect: ImportOverviewFormSelects;
	setErrors: Dispatch<SetStateAction<CustomValidationError<CsvImportOverviewFormType>[]>>;
}

const ImportOverviewRequiredSearchSelect = ({ form, formSelect, setErrors }: Props) => {
	const {
		control,
		formState: { errors },
		watch,
	} = form;
	const { id, label, options } = formSelect;
	const formSelectValidationConfig = useMemo(() => {
		return {
			types: [{ constraint: CustomValidationConstraint.REQUIRED }],
			setErrors,
			utils: { watch },
		};
	}, [watch, setErrors]) satisfies CustomValidationConfig;

	return (
		<FormSelectGroup
			name={id}
			control={control}
			label={label}
			options={options}
			errors={errors}
			customValidationConfig={formSelectValidationConfig}
		/>
	);
};

export default ImportOverviewRequiredSearchSelect;
